// project imports
import { Logout } from 'utils/User';

// assets
import {
    IconDashboard,
    IconChecklist,
    IconShadow,
    IconLogout,
    IconShare,
    IconGavel,
    IconInfoCircle,
    IconStar,
    IconUsers,
    IconBuildingWarehouse,
    IconPackages,
    IconSitemap,
    IconCircleArrowDown,
    IconCircleArrowUp,
    IconCircleArrowRight,
    IconCornerLeftUpDouble,
    IconCornerRightDownDouble,
    IconAsset,
    IconChartBar,
    IconAssembly,
    IconTool,
    IconBuilding,
    IconBuildingBank,
    IconBuildingSkyscraper,
    IconBox,
    IconPlug,
    IconEdit,
    IconCalculator,
    IconArrowsExchange,
    IconCategory,
    IconReceipt2,
    IconSparkles,
    IconReportMoney
} from '@tabler/icons-react';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = (basisId, access, badges) => {
    if (!basisId) return [];

    const hasAccess = (name, props) => {
        return access?.includes(name) ? [props] : [];
    };

    return [
        {
            id: 'dashboard',
            title: 'پیشخوان',
            type: 'group',
            children: [
                {
                    id: 'default',
                    title: 'پیشخوان',
                    type: 'item',
                    url: '/dashboard',
                    icon: IconDashboard,
                    breadcrumbs: false
                },
                ...hasAccess('MC', {
                    id: 'persons',
                    title: 'مشتریان',
                    type: 'item',
                    url: `/basis/${basisId}/users?type=Person`,
                    icon: IconUsers,
                    breadcrumbs: false
                }),
                {
                    id: 'tasks',
                    title: 'وظایف',
                    type: 'item',
                    url: `/basis/${basisId}/tasks`,
                    icon: IconChecklist,
                    breadcrumbs: false,
                    ...(badges?.task ? { chip: { label: badges?.task?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }
            ]
        },
        {
            id: 'accountig',
            title: 'حسابداری',
            type: 'group',
            children: [
                ...hasAccess('BA', {
                    id: 'accounts',
                    title: 'حساب‌های بانکی',
                    type: 'item',
                    url: `/basis/${basisId}/accounts`,
                    icon: IconBuildingBank,
                    breadcrumbs: false
                }),
                ...hasAccess('BA', {
                    id: 'banks',
                    title: 'بانک‌ها',
                    type: 'item',
                    url: `/basis/${basisId}/banks`,
                    icon: IconBuildingBank,
                    breadcrumbs: false
                }),
                ...hasAccess('PP', {
                    id: 'payments',
                    title: 'دریافت و پرداخت',
                    type: 'item',
                    url: `/basis/${basisId}/payments`,
                    icon: IconArrowsExchange,
                    breadcrumbs: false
                }),
                ...hasAccess('PP', {
                    id: 'operations',
                    title: 'درآمد و هزینه',
                    type: 'item',
                    url: `/basis/${basisId}/operations`,
                    icon: IconCalculator,
                    breadcrumbs: false
                }),
                ...hasAccess('PP', {
                    id: 'cheques',
                    title: 'مدیریت چک',
                    type: 'item',
                    url: `/basis/${basisId}/cheques`,
                    icon: IconReceipt2,
                    breadcrumbs: false,
                    ...(badges?.cheque ? { chip: { label: badges?.cheque?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                // --------- NEW MENU ITEM --------- //
                ...hasAccess('IG', {
                    id: 'profit_loss',
                    title: 'سود و زیان',
                    type: 'item',
                    url: `/basis/${basisId}/profit_loss`,
                    icon: IconReportMoney,
                    breadcrumbs: false
                }),
                // --------------------------------- //
                ...hasAccess('IS', {
                    id: 'stores',
                    title: 'انبـارها',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/stores`,
                    icon: IconBuildingWarehouse,
                    breadcrumbs: false
                }),
                ...hasAccess('IP', {
                    id: 'products',
                    title: 'کــالاها',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/products`,
                    icon: IconPackages,
                    breadcrumbs: false
                }),
                ...hasAccess('IV', {
                    id: 'services',
                    title: 'خـدمات',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/services`,
                    icon: IconSitemap,
                    breadcrumbs: false
                }),
                ...hasAccess('IR', {
                    id: 'entries',
                    title: 'فاکتور خرید',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/transfers?type=In`,
                    icon: IconCircleArrowDown,
                    breadcrumbs: false,
                    ...(badges?.entry ? { chip: { label: badges?.entry?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                ...hasAccess('II', {
                    id: 'invoices',
                    title: 'فاکتور فروش',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/transfers?type=Out`,
                    icon: IconCircleArrowUp,
                    breadcrumbs: false,
                    ...(badges?.invoice ? { chip: { label: badges?.invoice?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                ...hasAccess('IT', {
                    id: 'transfers',
                    title: 'انتقال کالا',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/transfers?type=Transfer`,
                    icon: IconCircleArrowRight,
                    breadcrumbs: false,
                    ...(badges?.transfer ? { chip: { label: badges?.transfer?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                ...hasAccess('IE', {
                    id: 'return_in',
                    title: 'برگشت از خرید',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/transfers?type=Return In`,
                    icon: IconCornerLeftUpDouble,
                    breadcrumbs: false,
                    ...(badges?.returnIn ? { chip: { label: badges?.returnIn?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                ...hasAccess('IE', {
                    id: 'return_out',
                    title: 'برگشت از فروش',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/transfers?type=Return Out`,
                    icon: IconCornerRightDownDouble,
                    breadcrumbs: false,
                    ...(badges?.returnOut ? { chip: { label: badges?.returnOut?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                ...hasAccess('ID', {
                    id: 'productions',
                    title: 'سفارش تولید',
                    type: 'item',
                    url: `/basis/${basisId}/accounting/transfers?type=Production`,
                    icon: IconAsset,
                    breadcrumbs: false,
                    ...(badges?.production
                        ? { chip: { label: badges?.production?.toLocaleString(), color: 'warning', size: 'small' } }
                        : {})
                }),
                ...hasAccess('IG', {
                    id: 'reports',
                    title: 'گـزارش',
                    type: 'item',
                    url: `/basis/${basisId}/reports`,
                    icon: IconChartBar,
                    breadcrumbs: false
                })
            ]
        },
        {
            id: 'repairs',
            title: 'تعمیرات',
            type: 'group',
            children: [
                ...hasAccess('RR', {
                    id: 'receipts',
                    title: 'رسید تعمیر',
                    type: 'item',
                    url: `/basis/${basisId}/receipts`,
                    icon: IconTool,
                    breadcrumbs: false,
                    ...(badges?.receipt ? { chip: { label: badges?.receipt?.toLocaleString(), color: 'warning', size: 'small' } } : {})
                }),
                ...hasAccess('DP', {
                    id: 'departments',
                    title: 'بخـش‌ها',
                    type: 'item',
                    url: `/basis/${basisId}/departments`,
                    icon: IconBuilding,
                    breadcrumbs: false
                }),
                ...hasAccess('RS', {
                    id: 'repair_statuses',
                    title: 'وضعیت تعمیر',
                    type: 'item',
                    url: `/basis/${basisId}/repair_statuses`,
                    icon: IconAssembly,
                    breadcrumbs: false
                }),
                ...hasAccess('BR', {
                    id: 'brands',
                    title: 'بـرندها',
                    type: 'item',
                    url: `/basis/${basisId}/brands`,
                    icon: IconBuildingSkyscraper,
                    breadcrumbs: false
                }),
                ...hasAccess('DV', {
                    id: 'devices',
                    title: 'دستگاه‌ها',
                    type: 'item',
                    url: `/basis/${basisId}/devices`,
                    icon: IconBox,
                    breadcrumbs: false
                }),
                ...hasAccess('RR', {
                    id: 'accessories',
                    title: 'لوازم همراه',
                    type: 'item',
                    url: `/basis/${basisId}/accessories`,
                    icon: IconPlug,
                    breadcrumbs: false
                })
            ]
        },
        {
            id: 'features',
            title: 'امکانات',
            type: 'group',
            children: [
                ...hasAccess('MO', {
                    id: 'users',
                    title: 'کاربران',
                    type: 'item',
                    url: `/basis/${basisId}/users?type=User`,
                    icon: IconUsers,
                    breadcrumbs: false
                }),
                ...hasAccess('MF', {
                    id: 'report_designer',
                    title: 'طراح گزارش',
                    type: 'item',
                    url: `/basis/${basisId}/report_designer`,
                    icon: IconEdit,
                    breadcrumbs: false
                }),
                {
                    id: 'plans',
                    title: 'تمدید / ارتقای حساب',
                    type: 'item',
                    url: `/basis/${basisId}/upgrade`,
                    icon: IconSparkles,
                    breadcrumbs: false
                },
                {
                    id: 'share',
                    title: 'اشتراک‌گذاری برنامه',
                    type: 'item',
                    url: '/share',
                    icon: IconShare,
                    breadcrumbs: false
                },
                {
                    id: 'rate',
                    title: 'امتیاز به برنامه',
                    type: 'item',
                    url: '/rate',
                    icon: IconStar,
                    breadcrumbs: false
                },
                {
                    id: 'gavel',
                    title: 'قوانین و مقررات',
                    type: 'item',
                    url: '/terms',
                    icon: IconGavel,
                    breadcrumbs: false
                },
                {
                    id: 'about',
                    title: 'درباره‌ی ما',
                    type: 'item',
                    url: '/about',
                    icon: IconInfoCircle,
                    breadcrumbs: false
                },
                {
                    id: 'faq',
                    title: 'سؤالات متداول',
                    type: 'item',
                    url: '/faq',
                    icon: IconShadow,
                    breadcrumbs: false
                },
                {
                    id: 'logout',
                    title: 'خروج از حساب',
                    type: 'item',
                    url: '#',
                    onClick: Logout,
                    icon: IconLogout,
                    breadcrumbs: false
                }
            ]
        }
    ];
};

export default menuItems;
